import React, { Component } from 'react';
import RequestServiceForm from '../forms/RequestServiceForm';
import Breadcrumb from '../navs/Breadcrumb';
import Footer from '../navs/Footer';
import NavBar from '../navs/Navbar';

class RequestService extends Component {

    render() {
        return (
            <div>
                <NavBar />
                <Breadcrumb />
                <div>
                    <section className="portfolio-details mt-n5" style={{ padding: '20px' }}>
                        <div className="container">
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="col-md-4" data-aos="fade-up"> 
                                    <img src="assets/img/services/7.webp" className="img-fluid" alt="" style={{ width: "20em" }} />
                                    <div className="portfolio-description">
                                        <p>We don't just manage waste we provide solutions.<br/>Please provide us with your company details and service area and an agent will assist you.</p>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <section id="blog" className="blog">
                                        <div className="container-fl">
                                            <div className="row">
                                                <div className="col-lg-12  col-md-10 d-flex align-items-stretch entry" data-aos="fade-up">
                                                    <RequestServiceForm />
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        )
    }

}

export default RequestService;
